module.exports = __webpack_public_path__ + "static/media/indexed-dark.8b413b32.png";